import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Translate, ArrowCounterClockwise } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LANGS = ["Spanish", "French", "German", "Portuguese", "Italian", "Hindi", "Arabic", "Chinese (Simplified)", "Japanese", "Korean", "Russian", "Tamil", "Bengali", "Swahili"];

export default function MemorialTranslate({ mid, onTranslate, onReset, translated }) {
  const [lang, setLang] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (l) => {
    setLang(l);
    setBusy(true);
    try {
      const { data } = await api.post(`/memorials/${mid}/translate?lang=${encodeURIComponent(l)}`);
      onTranslate(data.fields || {}, l);
      toast.success(`Showing ${l} translation`);
    } catch { toast.error("Translation failed"); } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2" data-testid="memorial-translate">
      <Translate size={16} className="text-muted-foreground" />
      <Select value={lang} onValueChange={run} disabled={busy}>
        <SelectTrigger className="h-8 w-44 rounded-full text-xs" data-testid="translate-lang-select"><SelectValue placeholder={busy ? "Translating…" : "Translate…"} /></SelectTrigger>
        <SelectContent className="max-h-60">{LANGS.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}</SelectContent>
      </Select>
      {translated && (
        <Button variant="ghost" size="sm" className="h-8 rounded-full gap-1 text-xs text-muted-foreground" onClick={() => { setLang(""); onReset(); }} data-testid="translate-reset-btn">
          <ArrowCounterClockwise size={13} /> Original
        </Button>
      )}
    </div>
  );
}
